<template>
  <div class="space-y-2">
    <div class="bg-[#EEF1F6] border border-grayLight rounded-[6px] p-4">
      <div class="flex items-start gap-4">
        <div class="shrink-0 self-center">
          <img 
            :src="badge" 
            :alt="title"
            class="w-auto h-auto max-w-[45px] max-h-[66px]"
          />
        </div>

        <!-- Right: Content (title + earned badge, description) -->
        <div class="flex-1 min-w-0">
          <div class="flex items-center justify-between">
            <p v-if="title" class="text-[14px] font-semibold text-[#4C4D4F]">{{ title }}</p>
            <svg v-if="status === 'earned'" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="7" cy="7" r="7" fill="#1BFF00"/>
              <path d="M5.97913 9.49967L3.60413 7.12467L4.19788 6.53092L5.97913 8.31217L9.80204 4.48926L10.3958 5.08301L5.97913 9.49967Z" fill="#4C4D4F"/>
            </svg>
          </div>
          <p class="mt-2 text-[12px] text-bodyText">{{ description }}</p>
        </div>
      </div>
    </div>
    <div :class="['text-[12px]', statusClass]">
      <span>{{ statusLabel }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AchievementCard',
  props: {
    status: {
      type: String,
      default: 'not-earned',
      validator: (v) => ['earned', 'not-earned', 'close'].includes(v),
    },
    description: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    badge: {
      type: String,
      default: 'trophy', // trophy | award | medal
    },
  },
  computed: {
    statusLabel() {
      if (this.status === 'earned') return 'Earned';
      if (this.status === 'close') return 'Close to Earning keep up the good work';
      return 'Not earned';
    },
    statusClass() {
      if (this.status === 'earned') return 'text-bodyText italic';
      if (this.status === 'close') return 'text-bodyText italic';
      return 'text-[#98A2B3] italic';
    },
  }
};
</script>

<style scoped>
</style>
